function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 3.99988,
  width: 10,
  height: 11,
  fill: "#4081EB",
  fillOpacity: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.16797 1.66663H15.8346C16.0556 1.66663 16.2676 1.75442 16.4239 1.9107C16.5802 2.06698 16.668 2.27895 16.668 2.49996V17.5C16.668 17.721 16.5802 17.9329 16.4239 18.0892C16.2676 18.2455 16.0556 18.3333 15.8346 18.3333H4.16797C3.94696 18.3333 3.735 18.2455 3.57872 18.0892C3.42244 17.9329 3.33464 17.721 3.33464 17.5V2.49996C3.33464 2.27895 3.42244 2.06698 3.57872 1.9107C3.735 1.75442 3.94696 1.66663 4.16797 1.66663ZM8.99547 7.91663L8.16214 7.08329H8.09047L7.25714 7.91663H6.25131V4.16663H5.41797V15H14.5846V4.16663H10.0013V7.91663H8.99547ZM7.08464 6.91079L7.74547 6.24996H8.50714L9.16797 6.91079V2.49996H7.08464V6.91079ZM4.16797 17.5H15.8346V2.49996H10.0013V3.33329H15.418V15.8333H4.58464V3.33329H6.25131V2.49996H4.16797V17.5ZM10.8346 16.25H9.16797V17.0833H10.8346V16.25Z",
  fill: "#4081EB"
});

function SvgExamPrep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamPrep);
export default __webpack_public_path__ + "static/media/exam-prep.42ec8577.svg";
export { ForwardRef as ReactComponent };